import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import {Row, Col} from 'react-flexbox-grid'
import {SlideDown} from 'react-slidedown'
import config from '../../config'
import format from '../../helpers/format'
import {
  Link,
  LinkIcon,
  IyvListMobileSort,
  // IyvListCompareSelectIcon,
  IyvListTdReturns,
  IyvListTdNetAssets,
  IyvListTdSriUssif,
  IyvListTdGroupCategory,
  IyvListTdPercent,
  IyvListTdFossilFinanceGrade,
  IyvListTdDefault,
  IyvListTdGrade,
  IyvListTdGenderEqualityScore,
  IyvListTdGenderEqualityRank,
  IyvListTdFossilGrade,
} from '../../components'
import Styles from './IyvListMobileTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListMobileTable extends Component {
  static propTypes = {
    viewPanel: PropTypes.string,
    funds: PropTypes.array,
    sort: PropTypes.string,
    isDesc: PropTypes.bool,
    clickShareclass: PropTypes.func,
    clickCompareSelect: PropTypes.func,
    clickColumnHeader: PropTypes.func,
    activeGrouping: PropTypes.string,
    cart: PropTypes.object,
    getCompareSelectStyles: PropTypes.func,
    resultsTableColumns: PropTypes.object,
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return <div>
      <IyvListMobileSort
        sort={this.props.sort}
        isDesc={this.props.isDesc}
        clickColumnHeader={this.props.clickColumnHeader}
        resultsTableColumns={this.props.resultsTableColumns}
      />

      {
        this.props.funds.map((shareclass, idx) => {
          return <IyvListMobileTableRow
            key={`IyvListMobileTableRow-${idx}`}
            idx={idx}
            shareclass={shareclass}
            resultsTableColumns={this.props.resultsTableColumns}
            clickCompareSelect={this.props.clickCompareSelect}
            getCompareSelectStyles={this.props.getCompareSelectStyles}
            cart={this.props.cart}
            clickShareclass={this.props.clickShareclass}
            activeGrouping={this.props.activeGrouping}
          />
        })
      }
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListMobileTableRow extends Component {
  static propTypes = {
    idx: PropTypes.number,
    shareclass: PropTypes.object,
    resultsTableColumns: PropTypes.object,
    clickCompareSelect: PropTypes.func,
    getCompareSelectStyles: PropTypes.func,
    cart: PropTypes.object,
    clickShareclass: PropTypes.func,
    activeGrouping: PropTypes.string,
  }
  //
  constructor(props) {
    super(props)

    const { ticker, fund_legal_name, fund_id,
            investment_vehicle_id } = props.shareclass

    // make ticker safe for URL
    const sTicker = ticker || 'N'

    const urlBuilder = (route, profilePath) => {
      return route + '/' +
        format.sanitize(fund_legal_name) + '/' +
        sTicker + '/' +
        profilePath + '/' +
        fund_id + '/' +
        investment_vehicle_id
    }

    const url = urlBuilder(config.routes.fund, config.profilePath)

    let viewTabConfig = null
    switch (config.app.title) {
      case 'Fossil Free Funds':
        viewTabConfig = [
          ['results', 'Fossil fuels'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Deforestation Free Funds':
        viewTabConfig = [
          ['results', 'Deforestation'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Weapon Free Funds':
        viewTabConfig = [
          ['results', 'Military weapons'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Gun Free Funds':
        viewTabConfig = [
          ['results', 'Civilian firearms'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Tobacco Free Funds':
        viewTabConfig = [
          ['results', 'Tobacco'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Gender Equality Funds':
        viewTabConfig = [
          ['results', 'Gender equality'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Social Justice Funds':
        viewTabConfig = [
          ['results', 'Social justice'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Prison Free Funds':
        viewTabConfig = [
          ['results', 'Prison industrial complex'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Invest Your Values':
        viewTabConfig = [
          ['results', 'Sustainability'],
          ['performance', 'Performance'],
        ]
        break
      default:
        break
    }

    this.state = {
      fundUrl: url,
      viewTabConfig,
      resultsShow: true,
      performanceShow: false,
      iyvShow: false,
    }
  }
  //
  clickPanelButton = (v) => {
    const newState = {
      resultsShow: false,
      performanceShow: false,
      iyvShow: false,
    }
    // if requested panel already showing, close them all
    if (!this.state[v+'Show']) {
      newState[v+'Show'] = true
    }
    this.setState(newState)
  }
  //
  render() {
    return <div
      key={'ilmt-' + this.props.idx}
      styleName='ilmt-row'
    >
      <h3 styleName='ilmt-name'>{this.props.shareclass.name}</h3>
      <div styleName='ilmt-ticker'>{this.props.shareclass.ticker}</div>
      {
        this.state.viewTabConfig.map((e, _i) => {
          const panel = e[0]
          const label = e[1]
          return <IyvListMobileTableRowSection
            key={`IyvListMobileTableRowSection-${this.props.idx}-${_i}`}
            shareclass={this.props.shareclass}
            panel={panel}
            label={label}
            resultsTableColumns={this.props.resultsTableColumns}
            showPanel={this.state[panel+'Show']}
            panelLabel={label}
            clickPanelButton={this.clickPanelButton}
            clickShareclass={this.props.clickShareclass}
            activeGrouping={this.props.activeGrouping}
          />
        })
      }

      <div styleName='ilmt-compare'>
        { /* TODO mobile cart styling
          <IyvListCompareSelectIcon
            shareclass={this.props.shareclass}
            clickCompareSelect={this.props.clickCompareSelect}
            getCompareSelectStyles={this.props.getCompareSelectStyles}
            cart={this.props.cart}
            displayLabel
          />
        */ }
        <Link
          to={this.state.fundUrl}
          title={this.props.shareclass.name}
        >
          <div styleName='ilmt-profile-link'>
            Fund details<LinkIcon />
          </div>
        </Link>
      </div>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListMobileTableRowSection extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    panel: PropTypes.string,
    label: PropTypes.string,
    resultsTableColumns: PropTypes.object,
    showPanel: PropTypes.bool,
    panelLabel: PropTypes.string,
    clickPanelButton: PropTypes.func,
    clickShareclass: PropTypes.func,
    activeGrouping: PropTypes.string,
  }
  //
  constructor(props) {
    super(props)
    this.state = {
      cols: this.props.resultsTableColumns[config.app.title][this.props.panel]
    }
  }
  //
  render() {
    return <div>
      <button
        styleName='ilmt-panel-btn'
        onClick={() => { this.props.clickPanelButton(this.props.panel) }}
      >
        <div>
          {
            this.props.panel === 'results' ?
              this.props.panelLabel :
              this.props.label
          }
        </div>
        <div>
          <LinkIcon faclass={
            this.props.showPanel ?
              'fa-angle-up' :
              'fa-angle-down'
          } />
        </div>
      </button>
      <SlideDown>
        { /* for each column */
          this.props.showPanel ?
            <table styleName='ilmt-data-panel-table'>
              <tbody styleName='ilmt-data-panel'>
                {
                  this.state.cols.slice(1, this.state.cols.length).map((column, i) => {
                    // [label, prop] = column
                    return <tr
                      styleName='ilmt-data-panel-row'
                      key={`ilmt-data-panel-row-${i}`}
                    >
                      <td>
                        {column[0]}
                      </td>
                      <IyvListMobileTd
                        shareclass={this.props.shareclass}
                        fieldName={column[1]}
                        clickShareclass={this.props.clickShareclass}
                        activeGrouping={this.props.activeGrouping}
                      />
                    </tr>
                  })
                }
              </tbody>
            </table>:
            null
        }
      </SlideDown>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListMobileTd extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    fieldName: PropTypes.string.isRequired,
    clickShareclass: PropTypes.func.isRequired,
    activeGrouping: PropTypes.string,
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    //
    if (['fund_net_assets'].includes(this.props.fieldName)) {
      return <IyvListTdNetAssets
        shareclass={this.props.shareclass}
        mobile
      />
    }

    if (['ussif'].includes(this.props.fieldName)) {
      return <IyvListTdSriUssif
        shareclass={this.props.shareclass}
        mobile
      />
    }

    if (['prospectus_net_expense_ratio', 'trailing_return_y1',
         'trailing_return_y3', 'trailing_return_y5',
         'trailing_return_y10', 'trailing_return_y15',
         'trailing_return_y20'].includes(this.props.fieldName)) {
      return <IyvListTdReturns
        shareclass={this.props.shareclass}
        fieldName={this.props.fieldName}
        mobile
      />
    }

    if (['morningstar_category_name', 'category_group'].includes(this.props.fieldName)) {
      return <IyvListTdGroupCategory
        shareclass={this.props.shareclass}
        mobile
      />
    }

    if (['gm_weight','gr_weight','wff_civ_weight','pff_all_extreme_weight',
         'pff_all_high_weight','pp_high_weight','borders_high_weight',
         'pff_all_weight','cl_weight','po_producer_weight',
         'po_financier_weight','po_consumer_weight','po_all_weight',
         'mmc_weight','cm_weight','nw_weight','wff_mil_weight',
         'to_weight','tm_weight',
         't_all_weight'].includes(this.props.fieldName)) {
      return <IyvListTdPercent
        shareclass={this.props.shareclass}
        fieldName={this.props.fieldName}
        mobile
      />
    }

    if (['fossil_bank_score', 'fossil_insure_score'].includes(this.props.fieldName)) {
      return <IyvListTdFossilFinanceGrade
        shareclass={this.props.shareclass}
        fieldName={this.props.fieldName}
        clickShareclass={this.props.clickShareclass}
        mobile
      />
    }

    if (['grade_guns','grade_prison_industrial_complex','grade_fossil',
         'grade_deforestation','grade_gender_equality','grade_military',
         'grade_tobacco','grade_dei','grade_rji','grade_hrc'
      ].includes(this.props.fieldName)) {
      return <IyvListTdGrade
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
        fieldName={this.props.fieldName}
      />
    }

    if (['gef_score'].includes(this.props.fieldName)) {
      return <IyvListTdGenderEqualityScore
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
      />
    }

    if (['gef_grp_norm'].includes(this.props.fieldName)) {
      return <IyvListTdGenderEqualityRank
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
        activeGrouping={this.props.activeGrouping}
      />
    }

    if (['c2f5coogutweight'].includes(this.props.fieldName)) {
      return <IyvListTdFossilGrade
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
      />
    }

    return <IyvListTdDefault
      shareclass={this.props.shareclass}
      fieldName={this.props.fieldName}
      mobile
    />
  }
}
